export default __webpack_public_path__ + "static/media/Adil.c7f3bbea.jpg";